
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import $ from 'jquery';
export default {
components: {
XButton,
XHeader,
CheckIcon
},
data () {
return {
ownerId:"",
showzv:1,
noData:2,
taxCountData:{},
taxHouseApplyList:[],
readed:false,
}
},
created() {
this.$vux.loading.show({
text: '加载中',
})
this.getCountData();
},
mounted(){
},
methods:{
shengao(){
const _this = this 
this.$vux.confirm.show({

title:"确定提交计算申请吗？",
content:"按规则提交计算将会扣除"+_this.taxCountData.exes+"日元手续费",
onCancel () {
},
onConfirm () {
_this.$vux.loading.show({
text: '正在提交',
})
let loginData=JSON.parse(localStorage.getItem("loginData"));
let accessToken=loginData.access_token;
let token=loginData.token_type+" "+loginData.access_token;
$.ajax({
url : _this._Api.submitCal,
type: "POST",
contentType: "application/json;charset=utf-8",
data:JSON.stringify({"id":_this.taxCountData.id}),
beforeSend: function(xhr) {
xhr.setRequestHeader("Authorization", token);
},
success: function(res) {
_this.$vux.loading.hide();
_this.$vux.toast.show({
text: '提交成功'
})
setTimeout(() => {
location.reload();
}, 500)

},

error:function(res){

}

});
}
})
},
backHome(){
this.$router.push({
path: '/home'
});
},
drawLine(){
var that=this;

let myChart = this.$echarts.init(document.getElementById('myPie'))

myChart.setOption({
title : {
text: '托管资产表',
subtext: '单位日元',
x:'center'
},
tooltip: {
trigger: 'item',
formatter: "{a}{b}",
position: function (pos, params, dom, rect, size) {

var obj = {top: 60};
obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
return obj;
}
},
series: [
{
name:'',
type:'pie',

radius: [0, '42%'],
center: ['50%', '63%'],
label: {

normal: {
position:"center",
formatter: function(p) {
return p.name+"\n"+that.BM.formatMoney(p.value);
},

borderRadius:5,
color:"#fff",





padding: [6, 5],
rich: {
b: {
fontSize: 14,
lineHeight: 26,
color:"#fff"
},
c:{
fontSize: 14,
},
per: {
color: '#eee',
backgroundColor: '#334455',
padding: [2, 4],
borderRadius: 2
}
}
}
},





data:[
{value:that.taxCountData.sumAsset, name:'托管总资产'},

]
},
{
name:'',
type:'pie',
radius: ['45%', '63%'],
center: ['50%', '63%'],
label: {
normal: {
formatter: function(p) {
var name=p.name.replace(/\s+/g,"")
if(that.taxCountData.houseNum>7){
return that.BM.formatMoney(p.value);
}else{
if(name.length>20){
return name.slice(0,7)+"\n"+name.slice(7,13)+"\n"+name.slice(13,20)+"\n"+name.slice(20,27)+":\n"+that.BM.formatNum(p.value);
}if(name.length>13){
return name.slice(0,7)+"\n"+name.slice(7,13)+"\n"+name.slice(13,20)+":\n"+that.BM.formatNum(p.value);
}if(name.length>7){
return name.slice(0,7)+"\n"+name.slice(7,13)+":\n"+that.BM.formatNum(p.value);
}else{
return name+":\n"+that.BM.formatNum(p.value);
}
}
},







rich: {
b: {
fontSize: 14,
lineHeight: 26,
},
c:{
fontSize: 14,
},
per: {
color: '#eee',
backgroundColor: '#334455',
padding: [2, 4],
borderRadius: 2
}
}
}
},
data:that.taxHouseApplyList
}
]
});
},
changezc(){
this.$vux.loading.show({
text: '加载中',
})
setTimeout(() => {
this.$vux.loading.hide();
this.showzv=1;
}, 500)

},
changesz(){
this.$vux.loading.show({
text: '加载中',
})
setTimeout(() => {
this.$vux.loading.hide();
this.showzv=0;
}, 500)
setTimeout(() => {
this.drawLine();
}, 600)
},
drawPie(){
var that =this;
let myPie = this.$echarts.init(document.getElementById('myChart'))


myPie.setOption({
title : {
text: '2018年收支报表',
subtext: '单位日元',
x:'center'
},
legend: {
orient: 'vertical',
x: 'left',
top:20,
left:10,
data:['总收入','总支出']
},
series: [
{
name:'',
type:'pie',

radius: ['0%', '54%'],
center: ['50%', '68%'],
label: {
normal: {

formatter: function(p) {
return that.BM.formatMoney(p.value);
},


shadowBlur:3,
shadowOffsetX: 2,
shadowOffsetY: 2,
shadowColor: '#999',
padding: [0, 5],
rich: {
b: {
fontSize: 14,
lineHeight: 26,
},
c:{
fontSize: 14,
},
per: {
color: '#eee',
backgroundColor: '#334455',
padding: [2, 4],
borderRadius: 2
}
}
}
},
data:[
{value:that.taxCountData.income, name:'总收入'},
{value:that.taxCountData.outlay, name:'总支出'},
]
}
]
});
},
getCountData(){
let that=this;
let owner=JSON.parse(localStorage.getItem("ownerData"));
if(owner && owner.ownerId){
this.ownerId=owner.ownerId;
this.BM.JQajax({
url:this._Api.getCountData,
contentT:"application/json",
method:"GET",
data:{
"ownerId":that.ownerId,
},
success: function(data) {

that.$vux.loading.hide()
if(data.data){
that.taxCountData=data.data;
var houseData=that.taxCountData.taxHouseApplyList;
for(var i=0;i<houseData.length;i++){
let dataInd={value:houseData[i].asset,name:houseData[i].houseName};
that.taxHouseApplyList.push(dataInd);
}
that.noData=0;
setTimeout(() => {
that.drawPie();
}, 100)
}else{
that.noData=1;
}
},
error:function(data){
that.$vux.loading.hide()
that.$vux.toast.text(
'暂无权限，如是房主请咨询您的投资顾问'
)
that.noData=1;
},
unAuth:function(){
that.$vux.loading.hide()
localStorage.removeItem('loginData');
that.$router.push({
path: '/'
});
}
})
}else{
that.$vux.loading.hide()
that.noData=1;
}
},
}
}



// WEBPACK FOOTER //
// ./src/pages/taxCount.vue